module.exports = __webpack_public_path__ + "img/top-bg.f99a2191.png";